
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("7aarm", function(module, exports) {
$parcel$export(module.exports, "default", () => (parcelRequire("jdIYP")).default);

var $jdIYP = parcelRequire("jdIYP");






});

parcelRegister("bedQP", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $9JpPs = parcelRequire("9JpPs");

const $9aeacd26f36a9957$export$cf56d0f54cfcce4 = (featureFlagName, ComponentTrue, ComponentFalse)=>(0, $9JpPs.componentWithCondition)(()=>(0, $dh538.fg)(featureFlagName), ComponentTrue, ComponentFalse);
module.exports["componentWithFG"] = $9aeacd26f36a9957$export$cf56d0f54cfcce4;

});

parcelRegister("9JpPs", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

function $c712b10e1cbb5738$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>condition() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, $l998X.jsx)(ComponentTrue, {
            ...props,
            ref: ref
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, $l998X.jsx)(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}
module.exports["componentWithCondition"] = $c712b10e1cbb5738$export$6e8ea24b15199873;

});

parcelRegister("dpPtd", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aD1SW = parcelRequire("aD1SW");


var $eCEXz = parcelRequire("eCEXz");


var $6uGcC = parcelRequire("6uGcC");

const $c997cd3fd9f4ee84$var$FlagContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(null);
function $c997cd3fd9f4ee84$export$2879604e6aec4ab() {
    const api = (0, $42omo.useContext)($c997cd3fd9f4ee84$var$FlagContext);
    if (api == null) throw new Error('Unable to find FlagProviderContext');
    return api;
}
const $c997cd3fd9f4ee84$var$getUniqueId = (()=>{
    let count = 0;
    return ()=>`flag-provider-unique-id:${count++}`;
})();
function $c997cd3fd9f4ee84$export$a4270ab432ac8a58({ children: children, shouldRenderToParent: shouldRenderToParent }) {
    const [flags, setFlags] = (0, $42omo.useState)([]);
    const removeFlag = (0, $42omo.useCallback)((id)=>{
        setFlags((current)=>{
            return current.slice(0).filter((flag)=>flag.id !== id);
        });
    }, []);
    const api = (0, $42omo.useMemo)(()=>({
            showFlag: function show(value) {
                const flag = {
                    ...value,
                    id: value.id || $c997cd3fd9f4ee84$var$getUniqueId()
                };
                setFlags((current)=>{
                    const index = current.findIndex((value)=>value.id === flag.id);
                    // If flag is not found add it
                    if (index === -1) return [
                        flag,
                        ...current
                    ];
                    // If flag already exists with the same id, then replace it
                    const shallow = [
                        ...current
                    ];
                    shallow[index] = flag;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag.id);
                };
            }
        }), [
        removeFlag
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($c997cd3fd9f4ee84$var$FlagContext.Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6uGcC.default), {
                onDismissed: removeFlag,
                shouldRenderToParent: shouldRenderToParent,
                children: flags.map((flag)=>{
                    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag;
                    const FlagType = isAutoDismiss ? (0, $aD1SW.default) : (0, $eCEXz.default);
                    return /*#__PURE__*/ (0, $42omo.createElement)(FlagType, {
                        ...restProps,
                        key: flag.id
                    });
                })
            })
        ]
    });
}
const $c997cd3fd9f4ee84$export$7b676815c264eaf3 = (fn)=>/*#__PURE__*/ (0, $l998X.jsx)($c997cd3fd9f4ee84$export$a4270ab432ac8a58, {
        children: fn()
    });
module.exports["useFlags"] = $c997cd3fd9f4ee84$export$2879604e6aec4ab;
module.exports["FlagsProvider"] = $c997cd3fd9f4ee84$export$a4270ab432ac8a58;

});

parcelRegister("5qzNs", function(module, exports) {

var $5ukOg = parcelRequire("5ukOg");


var $ipwYn = parcelRequire("ipwYn");


var $5kt6R = parcelRequire("5kt6R");


var $f2rYC = parcelRequire("f2rYC");


var $gR42R = parcelRequire("gR42R");


var $5baaE = parcelRequire("5baaE");


var $5Nw7l = parcelRequire("5Nw7l");


var $jHiyU = parcelRequire("jHiyU");

/** Used to compose bitmasks for cloning. */ var $3f3b25eb0c07a9d2$var$CLONE_DEEP_FLAG = 1, $3f3b25eb0c07a9d2$var$CLONE_FLAT_FLAG = 2, $3f3b25eb0c07a9d2$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $3f3b25eb0c07a9d2$var$omit = $5Nw7l(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $5ukOg(paths, function(path) {
        path = $f2rYC(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $gR42R(object, $jHiyU(object), result);
    if (isDeep) result = $ipwYn(result, $3f3b25eb0c07a9d2$var$CLONE_DEEP_FLAG | $3f3b25eb0c07a9d2$var$CLONE_FLAT_FLAG | $3f3b25eb0c07a9d2$var$CLONE_SYMBOLS_FLAG, $5baaE);
    var length = paths.length;
    while(length--)$5kt6R(result, paths[length]);
    return result;
});
module.exports = $3f3b25eb0c07a9d2$var$omit;

});

parcelRegister("5kt6R", function(module, exports) {

var $f2rYC = parcelRequire("f2rYC");


var $apAFY = parcelRequire("apAFY");


var $9rfkh = parcelRequire("9rfkh");


var $w287Y = parcelRequire("w287Y");

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $3e1566926de40aab$var$baseUnset(object, path) {
    path = $f2rYC(path, object);
    object = $9rfkh(object, path);
    return object == null || delete object[$w287Y($apAFY(path))];
}
module.exports = $3e1566926de40aab$var$baseUnset;

});

parcelRegister("9rfkh", function(module, exports) {

var $aT80v = parcelRequire("aT80v");


var $3BqCC = parcelRequire("3BqCC");

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $6df28623e183fd76$var$parent(object, path) {
    return path.length < 2 ? object : $aT80v(object, $3BqCC(path, 0, -1));
}
module.exports = $6df28623e183fd76$var$parent;

});

parcelRegister("5baaE", function(module, exports) {

var $gTZCn = parcelRequire("gTZCn");

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $3c55de8c787dd7a6$var$customOmitClone(value) {
    return $gTZCn(value) ? undefined : value;
}
module.exports = $3c55de8c787dd7a6$var$customOmitClone;

});

parcelRegister("5Nw7l", function(module, exports) {

var $5qOzM = parcelRequire("5qOzM");


var $iK2Oc = parcelRequire("iK2Oc");


var $gnVVm = parcelRequire("gnVVm");

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $438a713c021efc47$var$flatRest(func) {
    return $gnVVm($iK2Oc(func, undefined, $5qOzM), func + '');
}
module.exports = $438a713c021efc47$var$flatRest;

});

parcelRegister("5qOzM", function(module, exports) {

var $8jC8i = parcelRequire("8jC8i");

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $3f469ccb29f16086$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $8jC8i(array, 1) : [];
}
module.exports = $3f469ccb29f16086$var$flatten;

});

parcelRegister("8jC8i", function(module, exports) {

var $hwwIB = parcelRequire("hwwIB");


var $ifqdW = parcelRequire("ifqdW");

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $60ddad71e9a2305d$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $ifqdW);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $60ddad71e9a2305d$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $hwwIB(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $60ddad71e9a2305d$var$baseFlatten;

});

parcelRegister("ifqdW", function(module, exports) {

var $agzqu = parcelRequire("agzqu");


var $dI6Ko = parcelRequire("dI6Ko");


var $fZxmY = parcelRequire("fZxmY");

/** Built-in value references. */ var $d48df83729a0e096$var$spreadableSymbol = $agzqu ? $agzqu.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $d48df83729a0e096$var$isFlattenable(value) {
    return $fZxmY(value) || $dI6Ko(value) || !!($d48df83729a0e096$var$spreadableSymbol && value && value[$d48df83729a0e096$var$spreadableSymbol]);
}
module.exports = $d48df83729a0e096$var$isFlattenable;

});

parcelRegister("keVvA", function(module, exports) {
$parcel$export(module.exports, "default", () => $36f6a30267bec70f$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1e2E5 = parcelRequire("1e2E5");


var $e9OZ6 = parcelRequire("e9OZ6");


var $5cR9p = parcelRequire("5cR9p");

function $36f6a30267bec70f$export$2e2bcd8739ae039({ loaderFn: loaderFn, children: children, defaultMessages: defaultMessages }) {
    const intl = (0, $5cR9p.useSafeIntl)();
    const messages = (0, $e9OZ6.useMessages)(intl.locale, loaderFn);
    /**
   * IntlProvider does not inherit from upstream IntlProviders,
   * we lookup messages in the context and pass them downstream
   * This prevents the missing messages error
   */ const mergedMessages = (0, $42omo.useMemo)(()=>{
        return {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
    }, [
        intl,
        messages,
        defaultMessages
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1e2E5.default), {
        defaultLocale: "en",
        locale: intl.locale,
        onError: intl.onError,
        messages: mergedMessages,
        children: children
    });
}

});

parcelRegister("e9OZ6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hxPth = parcelRequire("hxPth");

const $e1a1ee666860bb23$export$4d17e2d9c5348842 = (locale, loaderFn)=>{
    const [localeState, setLocaleState] = (0, $42omo.useState)((0, $hxPth.DEFAULT_LOCALE_STATE));
    (0, $42omo.useEffect)(()=>{
        if (!localeState.messages || locale !== localeState.locale) {
            let current = true;
            loaderFn(locale).then((messages)=>{
                if (current) setLocaleState({
                    locale: locale,
                    messages: messages ?? {}
                });
            });
            return ()=>{
                current = false;
            };
        }
        return undefined;
    }, [
        loaderFn,
        locale,
        localeState
    ]);
    return localeState.messages;
};
module.exports["useMessages"] = $e1a1ee666860bb23$export$4d17e2d9c5348842;

});

parcelRegister("hxPth", function(module, exports) {
const $b9a0da62d538b640$export$79618bef82c02d4c = {
    locale: 'en',
    messages: {}
};
module.exports["DEFAULT_LOCALE_STATE"] = $b9a0da62d538b640$export$79618bef82c02d4c;

});

parcelRegister("5cR9p", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1e2E5 = parcelRequire("1e2E5");

var $fI8ba = parcelRequire("fI8ba");

var $gmMgo = parcelRequire("gmMgo");


var $hxPth = parcelRequire("hxPth");

// Prevents memory leaks
const $1961b540cbe6be26$var$cache = (0, $fI8ba.createIntlCache)();
const $1961b540cbe6be26$export$f752ac21ea3960a5 = ()=>{
    const context = (0, $42omo.useContext)((0, $gmMgo.Context));
    if (!context) return (0, $1e2E5.createIntl)((0, $hxPth.DEFAULT_LOCALE_STATE), $1961b540cbe6be26$var$cache);
    return context;
};
module.exports["useSafeIntl"] = $1961b540cbe6be26$export$f752ac21ea3960a5;

});

parcelRegister("lvsjl", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa82743632a2ad8f$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $fa82743632a2ad8f$export$2e2bcd8739ae039(callback, delay, options) {
    if (options === void 0) options = {};
    var maxWait = options.maxWait;
    var maxWaitHandler = (0, $42omo.useRef)(null);
    var maxWaitArgs = (0, $42omo.useRef)([]);
    var leading = options.leading;
    var trailing = options.trailing === undefined ? true : options.trailing;
    var leadingCall = (0, $42omo.useRef)(false);
    var functionTimeoutHandler = (0, $42omo.useRef)(null);
    var isComponentUnmounted = (0, $42omo.useRef)(false);
    var debouncedFunction = (0, $42omo.useRef)(callback);
    debouncedFunction.current = callback;
    var cancelDebouncedCallback = (0, $42omo.useCallback)(function() {
        clearTimeout(functionTimeoutHandler.current);
        clearTimeout(maxWaitHandler.current);
        maxWaitHandler.current = null;
        maxWaitArgs.current = [];
        functionTimeoutHandler.current = null;
        leadingCall.current = false;
    }, []);
    (0, $42omo.useEffect)(function() {
        // We have to set isComponentUnmounted to be truth, as fast-refresh runs all useEffects
        isComponentUnmounted.current = false;
        return function() {
            // we use flag, as we allow to call callPending outside the hook
            isComponentUnmounted.current = true;
        };
    }, []);
    var debouncedCallback = (0, $42omo.useCallback)(function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        maxWaitArgs.current = args;
        clearTimeout(functionTimeoutHandler.current);
        if (leadingCall.current) leadingCall.current = false;
        if (!functionTimeoutHandler.current && leading && !leadingCall.current) {
            debouncedFunction.current.apply(debouncedFunction, args);
            leadingCall.current = true;
        }
        functionTimeoutHandler.current = setTimeout(function() {
            var shouldCallFunction = true;
            if (leading && leadingCall.current) shouldCallFunction = false;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current && trailing && shouldCallFunction) debouncedFunction.current.apply(debouncedFunction, args);
        }, delay);
        if (maxWait && !maxWaitHandler.current && trailing) maxWaitHandler.current = setTimeout(function() {
            var args = maxWaitArgs.current;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current) debouncedFunction.current.apply(null, args);
        }, maxWait);
    }, [
        maxWait,
        delay,
        cancelDebouncedCallback,
        leading,
        trailing
    ]);
    var callPending = (0, $42omo.useCallback)(function() {
        // Call pending callback only if we have anything in our queue
        if (!functionTimeoutHandler.current) return;
        debouncedFunction.current.apply(null, maxWaitArgs.current);
        cancelDebouncedCallback();
    }, [
        cancelDebouncedCallback
    ]);
    // At the moment, we use 3 args array so that we save backward compatibility
    return [
        debouncedCallback,
        cancelDebouncedCallback,
        callPending
    ];
}

});

parcelRegister("291hi", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9K4OG = parcelRequire("9K4OG");


var $ecnYn = parcelRequire("ecnYn");


var $lIKKD = parcelRequire("lIKKD");

const $725b0c40c654c097$var$hideAboveQueries = (0, $lIKKD.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'none'
});
const $725b0c40c654c097$var$hideBelowQueries = (0, $lIKKD.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'none'
});
const $725b0c40c654c097$export$bed28288a051538 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $ecnYn.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $9K4OG.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            above && $725b0c40c654c097$var$hideAboveQueries[above],
            below && $725b0c40c654c097$var$hideBelowQueries[below],
            ...resolvedStyles.emotion || []
        ]
    }, children);
};
module.exports["Hide"] = $725b0c40c654c097$export$bed28288a051538;

});

parcelRegister("lIKKD", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $1LBzd = parcelRequire("1LBzd");


var $bWLcG = parcelRequire("bWLcG");

const $4cf80e6d1c5d4415$export$918f8818cfbbeb2c = (input)=>{
    return (0, $1LBzd.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>({
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $9K4OG.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $bWLcG.media).above[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        }), {});
};
const $4cf80e6d1c5d4415$export$b2a4e2b0c6417297 = (input)=>{
    return (0, $1LBzd.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>{
        if (breakpoint === 'xxs') return acc;
        return {
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $9K4OG.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $bWLcG.UNSAFE_media).below[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        };
    }, {});
};
module.exports["UNSAFE_buildAboveMediaQueryCSS"] = $4cf80e6d1c5d4415$export$918f8818cfbbeb2c;
module.exports["UNSAFE_buildBelowMediaQueryCSS"] = $4cf80e6d1c5d4415$export$b2a4e2b0c6417297;

});

parcelRegister("1LBzd", function(module, exports) {
const $a161739fae125cf6$export$e5ee4fe8b989fd09 = {
    // mobile
    xxs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '0rem',
        max: '29.99rem'
    },
    // phablet
    xs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '30rem',
        max: '47.99rem'
    },
    // tablet
    sm: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-300, 24px)",
        min: '48rem',
        max: '63.99rem'
    },
    // laptop desktop
    md: {
        gridItemGutter: "var(--ds-space-300, 24px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '64rem',
        max: '89.99rem'
    },
    // monitor
    lg: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '90rem',
        max: '110.49rem'
    },
    // large high res
    xl: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-500, 40px)",
        min: '110.5rem',
        max: null
    }
}; //TODO: This `as const` should really be `satisfies Record<Breakpoint, BreakpointConfig>`, but that's not possible in our shipped TypeScript version yet.
const $a161739fae125cf6$export$2d293d9871c38e91 = Object.keys($a161739fae125cf6$export$e5ee4fe8b989fd09);
const $a161739fae125cf6$export$b7ed752a57b4177b = $a161739fae125cf6$export$2d293d9871c38e91[0];
module.exports["UNSAFE_BREAKPOINTS_ORDERED_LIST"] = $a161739fae125cf6$export$2d293d9871c38e91;

});

parcelRegister("26eSY", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9K4OG = parcelRequire("9K4OG");


var $ecnYn = parcelRequire("ecnYn");


var $lIKKD = parcelRequire("lIKKD");

function $81e208d7c03fb2bd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $81e208d7c03fb2bd$var$showAboveQueries = (0, $lIKKD.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'revert'
});
const $81e208d7c03fb2bd$var$showBelowQueries = (0, $lIKKD.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'revert'
});
const $81e208d7c03fb2bd$var$defaultHiddenStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $81e208d7c03fb2bd$export$f6a3d19be20f5819 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $ecnYn.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $9K4OG.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $81e208d7c03fb2bd$var$defaultHiddenStyles,
            above && $81e208d7c03fb2bd$var$showAboveQueries[above],
            below && $81e208d7c03fb2bd$var$showBelowQueries[below],
            ...resolvedStyles.emotion || []
        ]
    }, children);
};
module.exports["Show"] = $81e208d7c03fb2bd$export$f6a3d19be20f5819;

});

parcelRegister("24xEE", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $f4e2c76b2dc4439a$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $42omo.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $f4e2c76b2dc4439a$export$30ab340faaed55d4 = (experience)=>{
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            experience.abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $f4e2c76b2dc4439a$var$useConstructor(()=>experience.start());
    return null;
};
module.exports["useUFOComponentExperience"] = $f4e2c76b2dc4439a$export$30ab340faaed55d4;

});

parcelRegister("iKHTh", function(module, exports) {

var $aJT7b = parcelRequire("aJT7b");

const $19720d3977b4df3f$export$d4c4e98c5044dc8 = (0, $aJT7b.List);
module.exports["MenuList"] = $19720d3977b4df3f$export$d4c4e98c5044dc8;

});

parcelRegister("aJT7b", function(module, exports) {
/* list.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

function $002d225363d96747$var$_List({ children: children, testId: testId, xcss: xcss }, forwardedRef) {
    return(/**
     * We are using `role="list"` instead of a `ul` element to enable more flexible
     * composition. By using ARIA roles we can validly have elements between a list
     * and list items, as long as those in-between elements have no semantics.
     */ /*#__PURE__*/ (0, $l998X.jsx)("div", {
        role: "list",
        ref: forwardedRef,
        className: xcss,
        "data-testid": testId,
        children: children
    }));
}
const $002d225363d96747$export$54c2e3dc7acea9f5 = /*#__PURE__*/ (0, $42omo.forwardRef)($002d225363d96747$var$_List);
module.exports["List"] = $002d225363d96747$export$54c2e3dc7acea9f5;

});

parcelRegister("jh864", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8njHX = parcelRequire("8njHX");


var $jvL0g = parcelRequire("jvL0g");

const $bf400a28e0f66299$export$6dc09b7c0ec1dfcd = /*#__PURE__*/ (0, $42omo.forwardRef)(({ testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, isDisabled: isDisabled, isSelected: isSelected, elemBefore: elemBefore, actionsOnHover: actionsOnHover, onClick: onClick, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $jvL0g.MenuListItem), {
        ref: listItemRef,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8njHX.MenuItemBase), {
            testId: testId,
            description: description,
            elemAfter: elemAfter,
            elemBefore: elemBefore,
            isDisabled: isDisabled,
            /**
					 * Not passing `actions` and `actionsOnHover` to MenuItemBase when `isDisabled`,
					 * so they aren't rendered in the disabled state.
					 */ actions: isDisabled ? undefined : actions,
            actionsOnHover: isDisabled ? undefined : actionsOnHover,
            onClick: onClick,
            ariaControls: ariaControls,
            ariaExpanded: ariaExpanded,
            ariaHasPopup: ariaHasPopup,
            isSelected: isSelected,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator,
            children: children
        })
    });
});
module.exports["ButtonMenuItem"] = $bf400a28e0f66299$export$6dc09b7c0ec1dfcd;

});

parcelRegister("jItTa", function(module, exports) {
/* divider.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $5358d45118fa3975$var$styles = null; /**
                      * __Divider__
                      *
                      * A divider for use between menu sections.
                      */ 
const $5358d45118fa3975$export$2e0a83ec2e27ecbb = ()=>/*#__PURE__*/ (0, $l998X.jsx)("hr" /**
                                  * The existing usage of these dividers is presentational,
                                  * so we are removing the separator semantics by default.
                                  *
                                  * In the future we may consider allowing opt-in separator semantics,
                                  * but it probably isn't necessary.
                                  */ , {
        role: "none",
        className: (0, $gMc0m.default)([
            "_h7alglyw _179rglyw _mqm2ia51 _1bsb1osq"
        ])
    });
module.exports["Divider"] = $5358d45118fa3975$export$2e0a83ec2e27ecbb;

});

parcelRegister("l7sDu", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5aVN7 = parcelRequire("5aVN7");

var $24xEE = parcelRequire("24xEE");


var $4rFRN = parcelRequire("4rFRN");

function $eebcb10e5daa907f$var$useUFOExperience(id, config, instanceId) {
    return (0, $42omo.useMemo)(()=>new (0, $5aVN7.UFOExperience)(id, config, instanceId), [
        id,
        config,
        instanceId
    ]);
}
function $eebcb10e5daa907f$export$cdefb2a8b53f879f(key) {
    const experienceObj = (0, $4rFRN.NavigationExperienceId)[key];
    const experience = $eebcb10e5daa907f$var$useUFOExperience(experienceObj.experienceId, experienceObj.config, experienceObj.instanceId);
    (0, $24xEE.useUFOComponentExperience)(experience); // this hook starts the experience and aborts it when the component is unmounted
    return experience;
}
function $eebcb10e5daa907f$export$15f9dc99109fec75(key) {
    const experienceObj = (0, $4rFRN.NavigationExperienceId)[key];
    return new (0, $5aVN7.UFOExperience)(experienceObj.experienceId, experienceObj.config, experienceObj.instanceId);
}
module.exports["useExperienceTracker"] = $eebcb10e5daa907f$export$cdefb2a8b53f879f;
module.exports["createExperienceTracker"] = $eebcb10e5daa907f$export$15f9dc99109fec75;

});

parcelRegister("bNwbD", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $95c4b21f9fd4bea1$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $42omo.useEffect) : (0, $42omo.useLayoutEffect);
module.exports["useLayoutEffect"] = $95c4b21f9fd4bea1$export$e5c5a5f917a5871c;

});

parcelRegister("fFc6D", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $bNwbD = parcelRequire("bNwbD");


var $bWLcG = parcelRequire("bWLcG");

const $1487a997836a60f3$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).below.xl.replace('@media ', '').trim())
};
const $1487a997836a60f3$export$49e55ae2c03d6045 = (queryString, listener)=>{
    const listenerRef = (0, $42omo.useRef)(listener);
    (0, $42omo.useEffect)(()=>{
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
	 * We explicitly only react to boolean changes for binding our listener
	 * Changes to the functional reference are ignored.
	 */ const hasListener = !!listener;
    /**
	 * The `matchMedia(…)` return value for our breakpoint query.
	 */ const mq = $1487a997836a60f3$var$queries[queryString];
    (0, $bNwbD.useLayoutEffect)(()=>{
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $fFa3V.bind)(mq, {
            type: 'change',
            listener: (event)=>{
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};
module.exports["UNSAFE_useMediaQuery"] = $1487a997836a60f3$export$49e55ae2c03d6045;

});

parcelRegister("56Pe5", function(module, exports) {
/* withLoomVideoConfig.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $jBSD2 = parcelRequire("jBSD2");


var $f93jI = parcelRequire("f93jI");

function $41a6639f831557fa$export$177c7fac42e9cb39(WrappedComponent) {
    return function WithLoomVideoConfigComponent(props) {
        const { context: context, product: product, subProduct: subProduct } = props;
        const customisedItemConfig = (0, $jBSD2.useLoomVideoConfig)({
            cloudId: context.cloudId,
            productName: (0, $f93jI.convertSourceProductToProductType)(product, subProduct),
            environment: context.environment || 'prod',
            onItemClick: context.onItemClick,
            product: product,
            subProduct: subProduct
        });
        return /*#__PURE__*/ (0, $l998X.jsx)(WrappedComponent, {
            ...props,
            customisedItemConfig: customisedItemConfig
        });
    };
}
module.exports["withLoomVideoConfig"] = $41a6639f831557fa$export$177c7fac42e9cb39;

});

parcelRegister("jBSD2", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $9syPb = parcelRequire("9syPb");


var $9DI9J = parcelRequire("9DI9J");


var $4yxnV = parcelRequire("4yxnV");

const $16790efd08bff5cb$var$messages = (0, $cgtv4.defineMessages)({
    insertButtonText: {
        id: "universal-create.loom-video-menu-item.share-video",
        defaultMessage: "Share"
    }
});
function $16790efd08bff5cb$export$d8ef0486cf8cfe05({ cloudId: cloudId, productName: productName, environment: environment = 'prod', onItemClick: onItemClick, skipInitialisation: skipInitialisation = false, product: product, subProduct: subProduct }) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const attributes = {
        isNav4: true,
        product: product,
        subProduct: subProduct
    };
    const { openLoomRecorder: openLoomRecorder, recorderState: recorderState } = (0, $9syPb.useLoomRecorderEntryPoint)({
        entryPointLocation: (0, $4yxnV.SOURCE_LOCATION),
        environment: environment,
        cloudId: cloudId,
        productName: productName,
        onInsert: (videoUrl)=>{
            const url = new URL(videoUrl);
            // Open video in new tab with share permissions modal open
            url.searchParams.set('open_share_permissions', '1');
            window.open(url.toString(), '_blank', 'noopener');
        },
        insertButtonText: formatMessage($16790efd08bff5cb$var$messages.insertButtonText),
        eventHandler: {
            onRecordingComplete: ()=>createAnalyticsEvent({
                    action: 'completed',
                    actionSubject: 'loomRecording',
                    eventType: 'track',
                    tags: [
                        (0, $9DI9J.ANALYTICS_TAG)
                    ],
                    attributes: attributes
                }).fire((0, $9DI9J.ANALYTICS_CHANNEL)),
            onUploadComplete: ()=>createAnalyticsEvent({
                    action: 'uploaded',
                    actionSubject: 'loomRecording',
                    eventType: 'track',
                    tags: [
                        (0, $9DI9J.ANALYTICS_TAG)
                    ],
                    attributes: attributes
                }).fire((0, $9DI9J.ANALYTICS_CHANNEL)),
            onInsertClicked: ()=>createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'insertVideoLink',
                    eventType: 'ui',
                    tags: [
                        (0, $9DI9J.ANALYTICS_TAG)
                    ],
                    attributes: attributes
                }).fire((0, $9DI9J.ANALYTICS_CHANNEL))
        },
        skipInitialisation: skipInitialisation
    });
    const onClick = (0, $42omo.useCallback)(()=>{
        if (openLoomRecorder) {
            onItemClick?.((0, $9DI9J.ATI_PRESETS).LOOM);
            openLoomRecorder();
        }
    }, [
        openLoomRecorder,
        onItemClick
    ]);
    switch(recorderState){
        case 'initialising':
            return {
                isLoading: true
            };
        case 'ready':
            if (openLoomRecorder) return {
                onClick: onClick
            };
            return {
                isDisabled: true
            };
        default:
            return {
                isDisabled: true
            };
    }
}
module.exports["useLoomVideoConfig"] = $16790efd08bff5cb$export$d8ef0486cf8cfe05;

});

parcelRegister("9syPb", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $dh538 = parcelRequire("dh538");


var $jJf3a = parcelRequire("jJf3a");


var $cglvp = parcelRequire("cglvp");


var $b6A6z = parcelRequire("b6A6z");

const $b5fbe98a0f081479$export$c8d9dc913e9e33ec = ({ entryPointLocation: entryPointLocation, environment: environment, cloudId: cloudId, productName: productName, onInsert: onInsert, insertButtonText: insertButtonText, openInBugReportMode: openInBugReportMode, renderOnInsertFallbackWhen: renderOnInsertFallbackWhen, skipInitialisation: skipInitialisation, eventHandler: eventHandler })=>{
    const singletonLoomSDKRef = (0, $42omo.useRef)();
    const [loomInitError, setLoomInitError] = (0, $42omo.useState)();
    const [recorderState, setRecorderState] = (0, $42omo.useState)('initialising');
    const updateOnInsertIfUnmountedRef = (0, $42omo.useRef)();
    const experienceTracker = (0, $42omo.useContext)((0, $jJf3a.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        async function initLoom() {
            const initResult = await (0, $b6A6z.initLoomSDK)({
                environment: environment,
                cloudId: cloudId,
                productName: productName,
                experienceTracker: experienceTracker,
                entryPointLocation: entryPointLocation
            });
            if (initResult.kind === 'success') {
                singletonLoomSDKRef.current = initResult.loomSDKInstance;
                // TODO - we need to set this to the current state of the singleton (maybe it's already recording), but currently no way to subscibe to changes in the global state
                setRecorderState('ready');
            } else {
                setLoomInitError(initResult.initError);
                setRecorderState('initialisation-failed');
            }
        }
        if (!skipInitialisation) initLoom();
    // Assumption - the dependencies cannot change without a full page regresh
    }, [
        environment,
        cloudId,
        productName,
        experienceTracker,
        skipInitialisation,
        entryPointLocation,
        createAnalyticsEvent
    ]);
    // eslint-disable-next-line arrow-body-style
    (0, $42omo.useEffect)(()=>{
        // this will run on unmount
        return function changeOnInsertBehaviorOnUnmount() {
            if (!singletonLoomSDKRef.current || !updateOnInsertIfUnmountedRef.current) return;
            if (renderOnInsertFallbackWhen === 'unmount') updateOnInsertIfUnmountedRef.current();
        };
    }, [
        renderOnInsertFallbackWhen
    ]);
    const openLoomRecorder = (0, $42omo.useCallback)(()=>{
        try {
            (0, $cglvp.OPEN_LOOM_RECORDER_SDK_INTERACTION_METRIC).start();
            experienceTracker.start({
                id: (0, $cglvp.RECORD_LOOM_ENTRY_POINT),
                name: (0, $cglvp.RECORD_LOOM_ENTRY_POINT),
                attributes: {
                    entryPointLocation: entryPointLocation
                }
            });
            // TODO - another instance can try to open the recorder while it's doing something else, we should disallow that by subscribing to the singleton state
            if (singletonLoomSDKRef.current === undefined) {
                (0, $cglvp.OPEN_LOOM_RECORDER_SDK_INTERACTION_METRIC).cancel();
                const failureReason = 'still-initialising';
                experienceTracker.abort({
                    name: (0, $cglvp.RECORD_LOOM_ENTRY_POINT),
                    reason: failureReason,
                    attributes: {
                        entryPointLocation: entryPointLocation
                    }
                });
                return {
                    isSuccess: false,
                    failureReason: failureReason
                };
            }
            if (singletonLoomSDKRef.current.status().state === 'active-recording') {
                (0, $cglvp.OPEN_LOOM_RECORDER_SDK_INTERACTION_METRIC).cancel();
                const failureReason = 'already-recording';
                experienceTracker.abort({
                    name: (0, $cglvp.RECORD_LOOM_ENTRY_POINT),
                    reason: failureReason,
                    attributes: {
                        entryPointLocation: entryPointLocation
                    }
                });
                return {
                    isSuccess: false,
                    failureReason: failureReason
                };
            }
            const { configureButton: configureButton, updateConfig: updateConfig } = singletonLoomSDKRef.current;
            const sdkButton = configureButton();
            updateConfig({
                config: {
                    insertButtonText: insertButtonText,
                    entryPointName: entryPointLocation
                }
            });
            sdkButton.on('start', ()=>{
                eventHandler?.onStart?.();
            });
            sdkButton.on('recording-start', ()=>{
                eventHandler?.onRecordingStarted?.();
                setRecorderState('recording');
            });
            sdkButton.on('cancel', ()=>{
                eventHandler?.onCancel?.();
            });
            sdkButton.on('complete', ()=>{
                eventHandler?.onComplete?.();
            });
            sdkButton.on('recording-complete', (video)=>{
                eventHandler?.onRecordingComplete?.(video);
            });
            sdkButton.on('upload-complete', (video)=>{
                eventHandler?.onUploadComplete?.(video);
            });
            sdkButton.on('insert-click', (video)=>{
                onInsert(video.sharedUrl, video);
                eventHandler?.onInsertClicked?.(false, video);
                experienceTracker.succeed({
                    name: (0, $cglvp.RECORD_LOOM_ENTRY_POINT),
                    attributes: {
                        inserted: true,
                        entryPointLocation: entryPointLocation
                    }
                });
            });
            updateOnInsertIfUnmountedRef.current = ()=>{
                updateConfig({
                    config: {
                        // TODO - format message?
                        insertButtonText: 'Open on Loom'
                    }
                });
                sdkButton.off('insert-click');
                sdkButton.on('insert-click', (video)=>{
                    if (typeof window !== 'undefined') {
                        window.open(video.sharedUrl, '_blank');
                        experienceTracker.succeed({
                            name: (0, $cglvp.RECORD_LOOM_ENTRY_POINT),
                            attributes: {
                                inserted: true,
                                insertFunctionWasReset: true,
                                entryPointLocation: entryPointLocation
                            }
                        });
                    }
                    eventHandler?.onInsertClicked?.(true, video);
                });
            };
            sdkButton.on('lifecycle-update', (lifecycleState)=>{
                if (lifecycleState === 'pre-recording') {
                    setRecorderState('pre-recording');
                    (0, $cglvp.OPEN_LOOM_RECORDER_SDK_INTERACTION_METRIC).stop();
                } else if (lifecycleState === 'post-recording') {
                    if (typeof renderOnInsertFallbackWhen === 'function' && renderOnInsertFallbackWhen() && !!updateOnInsertIfUnmountedRef.current) updateOnInsertIfUnmountedRef.current();
                    setRecorderState('post-recording');
                } else if (lifecycleState === 'closed') {
                    setRecorderState('ready');
                    experienceTracker.succeed({
                        name: (0, $cglvp.RECORD_LOOM_ENTRY_POINT),
                        attributes: {
                            closed: true,
                            entryPointLocation: entryPointLocation
                        }
                    });
                    updateOnInsertIfUnmountedRef.current = undefined;
                } else if (lifecycleState === 'cascaded') experienceTracker.succeed({
                    name: (0, $cglvp.RECORD_LOOM_ENTRY_POINT),
                    attributes: {
                        cascaded: true,
                        entryPointLocation: entryPointLocation
                    }
                });
            });
            if ((0, $dh538.fg)('loom-chrome-extension-bug-report-mode')) sdkButton.openPreRecordPanel(openInBugReportMode === true ? {
                chromeExtensionRecordingMode: 'BUG_REPORT'
            } : undefined);
            else sdkButton.openPreRecordPanel();
            return {
                isSuccess: true
            };
        } catch (error) {
            (0, $cglvp.OPEN_LOOM_RECORDER_SDK_INTERACTION_METRIC).cancel();
            experienceTracker.fail({
                name: (0, $cglvp.RECORD_LOOM_ENTRY_POINT),
                error: error instanceof Error ? error : new Error('unknown error in openLoomRecorder'),
                attributes: {
                    entryPointLocation: entryPointLocation
                }
            });
            return {
                isSuccess: false,
                failureReason: 'unexpected-error'
            };
        }
    }, [
        onInsert,
        entryPointLocation,
        insertButtonText,
        openInBugReportMode,
        renderOnInsertFallbackWhen,
        experienceTracker,
        eventHandler
    ]);
    return loomInitError ? {
        recorderState: 'initialisation-failed',
        loomInitError: loomInitError,
        openLoomRecorder: null
    } : {
        openLoomRecorder: openLoomRecorder,
        loomInitError: null,
        recorderState: recorderState
    };
};
module.exports["useLoomRecorderEntryPoint"] = $b5fbe98a0f081479$export$c8d9dc913e9e33ec;

});

parcelRegister("4yxnV", function(module, exports) {
const $abc5163120463e20$export$c2ae99333adf8094 = 'universal-create';
module.exports["SOURCE_LOCATION"] = $abc5163120463e20$export$c2ae99333adf8094;

});

parcelRegister("f93jI", function(module, exports) {
function $50e35123ed7ddc94$export$f8e8ac264d7fe02e(product, subProduct) {
    switch(product){
        case 'townsquare':
            if (subProduct === 'goal') return 'GOAL';
            if (subProduct === 'teams') return 'TEAMS';
            if (subProduct === 'home') return 'HOME';
            return 'TOWNSQUARE';
        case 'confluence':
            return 'CONFLUENCE';
        case 'rovoExtension':
            return 'ROVO_EXTENSION';
        default:
            return 'UNKNOWN';
    }
}
module.exports["convertSourceProductToProductType"] = $50e35123ed7ddc94$export$f8e8ac264d7fe02e;

});

parcelRegister("jdIYP", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $bedQP = parcelRequire("bedQP");


var $lGgRw = parcelRequire("lGgRw");


var $19BZl = parcelRequire("19BZl");


var $7K3dX = parcelRequire("7K3dX");


var $VSkIN = parcelRequire("VSkIN");


var $9OhGR = parcelRequire("9OhGR");

var $kbvzd = parcelRequire("kbvzd");
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $8C5kA = parcelRequire("8C5kA");


var $dpPtd = parcelRequire("dpPtd");





var $4jETc = parcelRequire("4jETc");

var $caUKj = parcelRequire("caUKj");

var $dv953 = parcelRequire("dv953");

var $fP8Uu = parcelRequire("fP8Uu");


var $cei05 = parcelRequire("cei05");


var $5lgDB = parcelRequire("5lgDB");


var $9DI9J = parcelRequire("9DI9J");


var $jjCkw = parcelRequire("jjCkw");





var $fMjA6 = parcelRequire("fMjA6");

var $6OnN8 = parcelRequire("6OnN8");


var $9A2e6 = parcelRequire("9A2e6");


var $arTHe = parcelRequire("arTHe");


var $hf2X4 = parcelRequire("hf2X4");


var $h03W7 = parcelRequire("h03W7");








var $a1Oiu = parcelRequire("a1Oiu");








var $a5rWO = parcelRequire("a5rWO");







function $3bd67b199eaebcfb$export$2eeb31739875ab1e({ crossAppCreationConfig: crossAppCreationConfig, product: product, subProduct: subProduct, sections: sections, skip: skip = false }) {
    const { locale: locale } = (0, $8C5kA.default)();
    const shouldSkip = skip || !crossAppCreationConfig.enabled;
    const shouldFetchV2Data = !shouldSkip && crossAppCreationConfig.enabled && crossAppCreationConfig.prefetch === true;
    // Convert sections to app menu config for V2 API (memoized to avoid recalculation)
    const appMenuConfig = (0, $42omo.useMemo)(()=>(0, $a5rWO.sectionsToAppMenuConfig)(sections), [
        sections
    ]);
    // Fetch V2 menu items
    const { data: data, hasError: hasError, fetchUCMenuItems: fetchUCMenuItems } = (0, $a1Oiu.useUCMenuItems)({
        cloudId: crossAppCreationConfig.enabled ? crossAppCreationConfig.cloudId : '',
        orgId: crossAppCreationConfig.enabled ? crossAppCreationConfig.orgId : '',
        userId: crossAppCreationConfig.enabled ? crossAppCreationConfig.accountId : '',
        product: product,
        locale: locale,
        subProduct: subProduct,
        appMenuConfig: appMenuConfig,
        skipInitialization: !shouldFetchV2Data
    });
    // Skip prefetching if there's an error
    const shouldSkipDueToError = hasError;
    // Check if Loom is enabled in the fetched data (only recalculate when data changes)
    const hasLoomEnabled = (0, $42omo.useMemo)(()=>{
        if (!data || shouldSkipDueToError || !data.sections || !Array.isArray(data.sections)) return false;
        // Check all sections for Loom items
        return data.sections.some((section)=>section && section.items && Array.isArray(section.items) && section.items.some((item)=>item && item.ati === (0, $9DI9J.ATI_PRESETS).LOOM));
    }, [
        data,
        shouldSkipDueToError
    ]);
    const shouldFetchLoom = shouldFetchV2Data && hasLoomEnabled && !shouldSkipDueToError;
    // Initialize Loom SDK if needed
    (0, $hf2X4.useLoomVideoConfig)({
        cloudId: crossAppCreationConfig.enabled ? crossAppCreationConfig.cloudId : '',
        productName: (0, $h03W7.convertSourceProductToProductType)(product),
        environment: crossAppCreationConfig.enabled && crossAppCreationConfig?.environment || 'prod',
        onItemClick: crossAppCreationConfig.enabled ? crossAppCreationConfig.onItemClick : undefined,
        skipInitialisation: !shouldFetchLoom
    });
    // Trigger fetch when conditions are met
    (0, $42omo.useEffect)(function fetchUCMenuItemsForV2() {
        if (shouldFetchV2Data) fetchUCMenuItems();
    }, [
        shouldFetchV2Data,
        fetchUCMenuItems
    ]);
    // Check if we need to fetch user data (only recalculate when data changes)
    const hasUserItemsRequired = (0, $42omo.useMemo)(()=>{
        if (!data || shouldSkipDueToError || !data.sections || !Array.isArray(data.sections)) return false;
        // Check all sections for items requiring user data
        return data.sections.some((section)=>section && section.items && Array.isArray(section.items) && section.items.some((item)=>item && item.ati && (0, $jjCkw.REQUIRED_USER_ITEMS).includes(item.ati)));
    }, [
        data,
        shouldSkipDueToError
    ]);
    const shouldFetchUser = shouldFetchV2Data && hasUserItemsRequired && !shouldSkipDueToError;
    return {
        shouldFetchV2Data: shouldFetchV2Data && !shouldSkipDueToError,
        shouldFetchLoom: shouldFetchLoom,
        shouldFetchUser: shouldFetchUser
    };
}


function $9b030845b586bf65$var$PrefetcherInner({ children: children, skipUserFetch: skipUserFetch }) {
    const crossAppCreationEnabled = (0, $dh538.fg)('navx_universal_create_cross_app_creation_enabled');
    const { product: product, suggestionConfig: suggestionConfig, subProduct: subProduct, crossAppCreationConfig: crossAppCreationConfig, sections: sections } = (0, $19BZl.useUniversalCreateState)(); // Determine if prefetch is enabled based on suggestionConfig.prefetch
    const isPrefetchEnabled = suggestionConfig.enabled && suggestionConfig.prefetch === true;
    const { locale: locale } = (0, $8C5kA.default)(); // This gets around TypeScript errors where it doesn't understand that we expect suggestionConfig to be
    // of type SuggestionConfigEnabled where we check for and use onResultChange, never SuggestionConfigDisabled
    const onResultChange = suggestionConfig.enabled ? suggestionConfig?.onResultChange : undefined; // Use the shared hooks for ATIs logic
    const nativeAtis = (0, $6OnN8.useSuggestionNativeAtis)();
    const preferredAtis = (0, $fMjA6.useSuggestionPreferredAtis)();
    const excludeAtis = (0, $fMjA6.useSuggestionExcludeAtis)();
    const { status: status, data: data, isLoading: isLoading, hasError: hasError, fetchUCSuggestions: fetchUCSuggestions } = (0, $fP8Uu.useUCSuggestions)({
        cloudId: suggestionConfig.enabled ? suggestionConfig.cloudId : '',
        orgId: suggestionConfig.enabled ? suggestionConfig.orgId : '',
        userId: suggestionConfig.enabled ? suggestionConfig.accountId : '',
        product: product,
        locale: locale,
        subProduct: suggestionConfig.enabled ? subProduct : undefined,
        nativeAtis: nativeAtis,
        preferredAtis: preferredAtis,
        excludeAtis: excludeAtis
    });
    const hasLoomEnabled = !isLoading && !hasError && data?.items?.some((item)=>item.ati === (0, $9DI9J.ATI_PRESETS).LOOM);
    const skipInitialisation = !isPrefetchEnabled || !crossAppCreationEnabled || !hasLoomEnabled;
    const shouldFetchSuggestions = crossAppCreationEnabled && isPrefetchEnabled && suggestionConfig.enabled; // V2 prefetch logic for cross-app creation
    const { shouldFetchUser: shouldFetchUserV2 } = (0, $3bd67b199eaebcfb$export$2eeb31739875ab1e)({
        crossAppCreationConfig: crossAppCreationConfig,
        product: product,
        subProduct: subProduct,
        sections: sections
    });
    const { user: currentUser } = (0, $caUKj.useUserContext)();
    const { fetchUser: fetchUser } = (0, $dv953.useFetchUser)();
    const [user, setUser] = (0, $42omo.useState)(()=>currentUser ? currentUser : undefined);
    (0, $hf2X4.useLoomVideoConfig)({
        cloudId: suggestionConfig.enabled ? suggestionConfig.cloudId : '',
        productName: (0, $h03W7.convertSourceProductToProductType)(product),
        environment: suggestionConfig.enabled && suggestionConfig?.environment || 'prod',
        onItemClick: suggestionConfig.enabled ? suggestionConfig.onItemClick : undefined,
        skipInitialisation: skipInitialisation
    }); // Trigger fetch when environment changes
    (0, $42omo.useEffect)(function fetchUCSuggestionsForLoomEnabledApps() {
        if (shouldFetchSuggestions) fetchUCSuggestions();
    }, [
        shouldFetchSuggestions,
        fetchUCSuggestions
    ]); // Memoize the BFF status scenario we want to check against
    // so that our notifySuggestionResultChange effect does not run for all non-init statuses individually
    const bffHasInitialized = (0, $42omo.useMemo)(()=>{
        return status !== (0, $4jETc.RequestStatus).INIT;
    }, [
        status
    ]); // Notify consumer when the suggestion result changes
    // (if they provided an onResultChange function and the conditions for whether to use it are met).
    // We call this in a second effect rather than after the fetchUCSuggestions promise resolves, in case
    // the data or error state changes some other way.
    (0, $42omo.useEffect)(function notifySuggestionResultChange() {
        // we should theoretically not need to check against shouldFetchSuggestions in this effect,
        // because if it's false the data/loading/error values should not change...as long as the BFF status is INIT.
        // If somehow the BFF status is not INIT, onResultChange would run if we didn't check this here.
        if (!shouldFetchSuggestions) return;
        if (onResultChange && bffHasInitialized) onResultChange?.({
            data: data,
            isLoading: isLoading,
            hasError: hasError
        });
    }, [
        onResultChange,
        data,
        isLoading,
        hasError,
        bffHasInitialized,
        shouldFetchSuggestions
    ]);
    const needFetchUser = (0, $42omo.useMemo)(()=>{
        return data?.items?.some((item)=>{
            return (0, $jjCkw.REQUIRED_USER_ITEMS).includes(item.ati);
        });
    }, [
        data?.items
    ]);
    (0, $42omo.useEffect)(function fetchUserConditionally() {
        async function getUser() {
            // If consumer provided a user, use that
            if (currentUser) {
                setUser(currentUser);
                return;
            } // otherwise fetch user once if not already provided by currentUser
            const fetchedUser = await fetchUser();
            if (fetchedUser) setUser(fetchedUser);
        }
        if ((needFetchUser || shouldFetchUserV2) && !skipUserFetch) getUser();
    }, [
        currentUser,
        fetchUser,
        needFetchUser,
        shouldFetchUserV2,
        skipUserFetch
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $caUKj.UserContext).Provider, {
        value: {
            user: user
        },
        children: children
    });
}
function $9b030845b586bf65$var$FlagsWrapper({ children: children }) {
    if ((0, $dh538.fg)('navx_uc_platformisation_forms_enabled')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $dpPtd.FlagsProvider), {
        children: children
    });
    return children;
}
function $9b030845b586bf65$export$96a2ac746aa7d3ab({ children: children, skipUserFetch: skipUserFetch }) {
    return /*#__PURE__*/ (0, $l998X.jsx)($9b030845b586bf65$var$PrefetcherInner, {
        skipUserFetch: skipUserFetch,
        children: children
    });
}
function $9b030845b586bf65$var$UFOWrapper({ children: children }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $5lgDB.NavigationUFOSegment), {
        id: "universalCreateComponentLoad",
        children: children
    });
}
function $9b030845b586bf65$var$TopLevelWrappersInner({ children: children, skipUserFetch: skipUserFetch }) {
    return /*#__PURE__*/ (0, $l998X.jsx)($9b030845b586bf65$var$UFOWrapper, {
        children: /*#__PURE__*/ (0, $l998X.jsx)($9b030845b586bf65$export$96a2ac746aa7d3ab, {
            skipUserFetch: skipUserFetch,
            children: /*#__PURE__*/ (0, $l998X.jsx)($9b030845b586bf65$var$FlagsWrapper, {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $arTHe.default), {
                    children: children
                })
            })
        })
    });
}
function $9b030845b586bf65$export$2374d7ac6bcc110a(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9A2e6.GenericErrorBoundary), {
        name: "top-level-wrappers",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $caUKj.BFFProvider), {
            consumer: (0, $4jETc.BFFConsumerEnum).UNIVERSAL_CREATE,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cei05.UniversalCreateBFFProvider), {
                children: /*#__PURE__*/ (0, $l998X.jsx)($9b030845b586bf65$var$TopLevelWrappersInner, {
                    ...props
                })
            })
        })
    });
}


var $37BdC = parcelRequire("37BdC");





var $3Qm0K = parcelRequire("3Qm0K");


var $hqYd7 = parcelRequire("hqYd7");


var $lz3e7 = parcelRequire("lz3e7");

function $4ddd708270831c0a$var$NoopComponent(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
        children: props.children
    });
}
const $4ddd708270831c0a$var$SectionExpansionContextProviderWithFG = (0, $bedQP.componentWithFG)('navx-2713-persist-more-state', (0, $19BZl.SectionExpansionContext).Provider, $4ddd708270831c0a$var$NoopComponent);
const $4ddd708270831c0a$var$GicModalProviderWithFG = (0, $bedQP.componentWithFG)('navx_enable_gic', (0, $3Qm0K.GicModalProvider), $4ddd708270831c0a$var$NoopComponent);
function $4ddd708270831c0a$var$SplitContextProviders({ children: children, menuControlContextV2Value: menuControlContextV2Value, menuStateContextValue: menuStateContextValue }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $19BZl.MenuControlContextV2).Provider, {
        value: menuControlContextV2Value,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $19BZl.MenuStateContext).Provider, {
            value: menuStateContextValue,
            children: children
        })
    });
}
function $4ddd708270831c0a$var$NoopWrapper({ children: children }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
        children: children
    });
}
const $4ddd708270831c0a$var$SplitContextProvidersWithFG = (0, $bedQP.componentWithFG)('navx_uc_context_refactor', $4ddd708270831c0a$var$SplitContextProviders, $4ddd708270831c0a$var$NoopWrapper);
/**
 * Type guard to check if props are v1 (has 'items' property)
 */ function $4ddd708270831c0a$var$isV1Props(props) {
    return 'items' in props;
}
/**
 * Type guard to check if props are v2 (has 'sections' property)
 */ function $4ddd708270831c0a$var$isV2Props(props) {
    return 'sections' in props;
}
function $4ddd708270831c0a$var$UniversalCreateButtonInner(props) {
    // ============================================================================
    // Props Extraction with Version Detection
    // ============================================================================
    // Extract common props (available in both v1 and v2)
    const { children: children, testId: testId, shouldRenderToParent: shouldRenderToParent, onClick: onClick, onClose: onClose, selectedItem: selectedItem, product: product, subProduct: subProduct, isOpen: controlledOpen = false, enableTriggerPulse: enableTriggerPulse = false, triggerButtonSpotlightTarget: triggerButtonSpotlightTarget, isNav4Enabled: isNav4Enabled = true, buttonTheme: buttonTheme, preventClose: preventClose = false, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, primaryActionItem: primaryActionItem } = props;
    // Extract version-specific props with type narrowing
    // V1 props
    const items = $4ddd708270831c0a$var$isV1Props(props) ? props.items : undefined;
    const suggestionConfig = $4ddd708270831c0a$var$isV1Props(props) ? props.suggestionConfig ?? {
        enabled: false
    } : {
        enabled: false
    };
    // V2 props
    const isV2Mode = $4ddd708270831c0a$var$isV2Props(props);
    const sections = (0, $42omo.useMemo)(()=>isV2Mode ? props.sections : [], // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        isV2Mode,
        isV2Mode && props.sections
    ]);
    const crossAppCreationConfig = isV2Mode ? props.crossAppCreationConfig ?? {
        enabled: false
    } : {
        enabled: false
    };
    // ============================================================================
    // Component Logic (unchanged from original)
    // ============================================================================
    const isResponsive = (0, $lz3e7.useIsResponsiveView)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(controlledOpen || false);
    const [sectionExpansionState, setSectionExpansionState] = (0, $42omo.useState)({});
    const setSectionExpanded = (0, $42omo.useCallback)((sectionIndex, expanded)=>{
        setSectionExpansionState((prev)=>({
                ...prev,
                [sectionIndex]: expanded
            }));
    }, []);
    // Normalize items for v1, or use empty array for v2
    const structuredItems = (0, $VSkIN.useNormalizeItems)(items ?? []);
    const defaultMenu = (0, $42omo.useCallback)(()=>isV2Mode ? /*#__PURE__*/ (0, $l998X.jsx)((0, $hqYd7.MenuContentV2), {}) : /*#__PURE__*/ (0, $l998X.jsx)((0, $9OhGR.default), {}), [
        isV2Mode
    ]);
    const [createContent, setCreateContent] = (0, $42omo.useState)(()=>defaultMenu);
    const { fireMenuStateChanged: fireMenuStateChanged } = (0, $7K3dX.useUniversalCreateAnalytics)();
    const reset = (0, $42omo.useCallback)(()=>{
        setCreateContent(()=>defaultMenu);
    }, [
        defaultMenu
    ]);
    const close = (0, $42omo.useCallback)(()=>{
        setCreateContent(()=>defaultMenu);
        setIsOpen(false);
    }, [
        defaultMenu
    ]);
    const load = (0, $42omo.useCallback)((loadCreateContent)=>{
        setCreateContent(()=>(contentProps)=>loadCreateContent(contentProps, {
                    reset: reset,
                    close: close
                }));
    }, [
        close,
        reset
    ]);
    const triggerButtonClick = (0, $42omo.useCallback)(()=>{
        setIsOpen((prev)=>{
            if (prev) onClose?.();
            return !prev;
        });
        onClick?.();
    }, [
        onClick,
        onClose,
        setIsOpen
    ]);
    const popupTrigger = (0, $42omo.useCallback)((triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $37BdC.TriggerButton), {
            testId: testId,
            triggerButtonSpotlightTarget: triggerButtonSpotlightTarget,
            enableTriggerPulse: enableTriggerPulse,
            isOpen: isOpen,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onClick: triggerButtonClick,
            triggerProps: triggerProps,
            isNav4Enabled: isNav4Enabled,
            buttonTheme: buttonTheme,
            primaryActionItem: primaryActionItem,
            children: children
        }), [
        children,
        enableTriggerPulse,
        isOpen,
        testId,
        triggerButtonClick,
        triggerButtonSpotlightTarget,
        buttonTheme,
        isNav4Enabled,
        onMouseEnter,
        onMouseLeave,
        primaryActionItem
    ]);
    const onCloseMenu = (0, $42omo.useCallback)(()=>{
        if (product === 'confluence' && preventClose) return;
        setIsOpen(false);
        setCreateContent(()=>defaultMenu);
        onClose?.();
    }, [
        defaultMenu,
        onClose,
        product,
        preventClose
    ]);
    const foundItem = (0, $42omo.useMemo)(()=>{
        if (!selectedItem) return null;
        if (isV2Mode) return (0, $VSkIN.findSelectedItemV2)(sections, selectedItem);
        return (0, $VSkIN.findSelectedItem)(structuredItems, selectedItem);
    }, [
        selectedItem,
        isV2Mode,
        sections,
        structuredItems
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isOpen) {
            const loadContent = foundItem?.loadCreateContent;
            if (loadContent) setCreateContent(()=>(contentProps)=>loadContent(contentProps, {
                        reset: reset,
                        close: close
                    }));
            else reset();
        }
    }, [
        close,
        isOpen,
        foundItem?.loadCreateContent,
        reset
    ]);
    (0, $42omo.useEffect)(()=>{
        if (controlledOpen !== undefined) {
            setIsOpen(controlledOpen);
            // Reset section expansion state when opening the menu
            if (controlledOpen && (0, $dh538.fg)('navx-2713-persist-more-state')) setSectionExpansionState({});
        }
    }, [
        controlledOpen
    ]);
    const prevIsOpenRef = (0, $42omo.useRef)(isOpen);
    (0, $42omo.useEffect)(()=>{
        const prevIsOpen = prevIsOpenRef.current;
        // Reset section expansion state when opening the menu
        if (isOpen && (0, $dh538.fg)('navx-2713-persist-more-state')) setSectionExpansionState({});
        // Only fire analytics on actual state transitions
        if (isOpen !== prevIsOpen) fireMenuStateChanged({
            itemState: isOpen ? 'expanded' : 'collapsed',
            version: isV2Mode ? 'v2' : 'v1'
        });
        prevIsOpenRef.current = isOpen;
    }, [
        isOpen,
        fireMenuStateChanged,
        prevIsOpenRef,
        isV2Mode
    ]);
    const loadPopupContent = (0, $42omo.useCallback)((props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $kbvzd.MenuWrapper), {
            children: createContent(props)
        }), [
        createContent
    ]);
    const popup = /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.Popup), {
        isOpen: isOpen,
        placement: isResponsive && isNav4Enabled || primaryActionItem ? 'bottom-end' : 'bottom-start',
        // eslint-disable-next-line @atlaskit/design-system/use-should-render-to-parent
        shouldRenderToParent: shouldRenderToParent,
        onClose: onCloseMenu,
        content: loadPopupContent,
        trigger: popupTrigger
    });
    // ============================================================================
    // MenuControlContext Value Construction
    // Populate context with appropriate values based on props version
    // ============================================================================
    const menuControlContextValue = {
        reset: reset,
        close: close,
        load: load,
        // V1 fields
        mixedItems: structuredItems,
        suggestionConfig: suggestionConfig ?? {
            enabled: false
        },
        sections: // V2 fields
        sections,
        crossAppCreationConfig: crossAppCreationConfig ?? {
            enabled: false
        },
        product: // Common fields
        product,
        subProduct: subProduct,
        isNav4Enabled: isNav4Enabled
    };
    // ============================================================================
    // Split Context Values for V2 Architecture (behind feature flag)
    // These provide the same data through split contexts during transition
    // ============================================================================
    const menuControlContextV2Value = {
        load: load,
        reset: reset,
        close: close
    };
    const menuStateContextValue = {
        isV2Mode: isV2Mode,
        items: structuredItems,
        product: product,
        subProduct: subProduct,
        crossAppCreationConfig: crossAppCreationConfig ?? {
            enabled: false
        },
        sections: sections,
        suggestionConfig: suggestionConfig ?? {
            enabled: false
        },
        isNav4Enabled: isNav4Enabled,
        preventClose: preventClose,
        controlledOpen: controlledOpen,
        primaryActionItem: primaryActionItem
    };
    const sectionExpansionContextValue = {
        sectionExpansionState: sectionExpansionState,
        setSectionExpansionState: setSectionExpanded
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $19BZl.MenuControlContext).Provider, {
        value: menuControlContextValue,
        children: /*#__PURE__*/ (0, $l998X.jsx)($4ddd708270831c0a$var$SplitContextProvidersWithFG, {
            menuControlContextV2Value: menuControlContextV2Value,
            menuStateContextValue: menuStateContextValue,
            children: /*#__PURE__*/ (0, $l998X.jsx)($4ddd708270831c0a$var$SectionExpansionContextProviderWithFG, {
                value: sectionExpansionContextValue,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9b030845b586bf65$export$2374d7ac6bcc110a), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)($4ddd708270831c0a$var$GicModalProviderWithFG, {
                        children: popup
                    })
                })
            })
        })
    });
}
function $4ddd708270831c0a$export$5c89068caaa33f77(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $arTHe.default), {
        children: /*#__PURE__*/ (0, $l998X.jsx)($4ddd708270831c0a$var$UniversalCreateButtonInner, {
            ...props
        })
    });
}
var $4ddd708270831c0a$export$2e2bcd8739ae039 = $4ddd708270831c0a$export$5c89068caaa33f77;
module.exports["default"] = $4ddd708270831c0a$export$2e2bcd8739ae039;

});


//# sourceMappingURL=universal-create.0f15f5a6.js.map
